import cx from 'clsx';

import {
  ModalWithMenuContent,
} from '@/components/modals/modal-with-menu-content';
import type {
  MenuList,
} from '@/components/modals/modal-with-menu-content/types';
import { getFormattedDateString } from '@/utils/string/formattedDate';

import { MODAL_TITLE } from './constants';
import styles from './styles.module.scss';
import type { Component } from './types';

export const BrochureModal: Component = ({
  brochureList,
  isOpen,
  onClose,
}) => {
  const brochureListForModal: MenuList[] = brochureList.map(
    ({ date, link, name }) => ({
      text: `${name} | uploaded ${getFormattedDateString(date.split(' ')[0], 'shorten', '-')}`,
      link,
    }),
  );

  return (
    <ModalWithMenuContent
      className={styles.containerBrochureModal}
      contentClassName={cx(
        styles.containerMenuContent,
        styles.isWidePadding,
      )}
      isOpen={isOpen}
      menuList={brochureListForModal}
      modalTitle={MODAL_TITLE}
      titleClassName={styles.containerTitle}
      onClose={onClose} />
  );
};
